import React, { useEffect, useState } from "react";
import api from "../admin/api";
import { Link } from "react-router-dom";
import PageHero from "../Components/PageHero";

function Blogs() {
  const [blogs, setBlogs] = useState([]);

 const getPreviewText = (html) => {
  const clean = cleanContent(html);

  // remove all HTML tags
  const text = clean.replace(/<[^>]+>/g, "");

  return text.substring(0, 120) + "...";
};

const cleanContent = (html) => {
  if (!html) return "";

  // decode HTML
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  let decoded = txt.value;

  // remove unwanted span tags
  decoded = decoded.replace(/<span[^>]*>/g, "");
  decoded = decoded.replace(/<\/span>/g, "");

  // fix encoded tags
  decoded = decoded.replace(/&lt;/g, "<").replace(/&gt;/g, ">");

  return decoded;
};

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await api.get("/UiplusBlogs");
      setBlogs(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const formatDate = (date) => {
  return new Date(date).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

  return (
    <>
      <PageHero
        title="Our Blogs"
        subtitle="Explore website development tips, digital marketing ideas, and business growth strategies"
      />

      <div className="container mt-5">
        <div className="row">
          
          {/* 🔹 LEFT SIDE - BLOGS */}
          <div className="col-lg-9">
            <div className="row">
              {blogs.map((item) => (
                <div key={item.id} className="col-md-6 mb-4">
                  <div className="card blog-card h-100 shadow-sm border-0">
                    
                    {/* Blog Image */}
                    {item.imageUrl && (
                      <img
                        src={item.imageUrl || "/no-image.png"}
                        alt={item.title}
                        className="card-img-top"
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                    )}

                    <div className="card-body d-flex flex-column">
                      <h5 className="fw-bold">{item.title}</h5>

                      <div className="text-muted mb-3" style={{ fontSize: "14px" }}>
                        📅 {formatDate(item.createdDate)} &nbsp; | &nbsp; ✍️ Admin
                      </div>

                      {/* Short Content */}
                      <div className="text-muted small mb-3">
                        {getPreviewText(item.content)}
                      </div>

                      {/* Button */}
                      <Link
                        to={`/blog/${item.slug}`}
                        className="btn btn-outline-success mt-auto"
                      >
                        Read More →
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 🔹 RIGHT SIDE - SIDEBAR */}
          <div className="col-lg-3">
            <div className="sidebar sticky-top" style={{ top: "100px" }}>
              
              {/* Products / Pages */}
              <div className="card p-3 mb-4 shadow-sm">
                <h5 className="fw-bold mb-3 border-bottom border-2 pb-3">Our Products</h5>

                <ul className="list-unstyled">
                  <li>
                    <Link to="/products" className="sidebar-link">
                      All Products
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/school-management" className="sidebar-link">
                      School ERP Software
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/finance-management" className="sidebar-link">
                      Finance Software
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/ecommerce-website" className="sidebar-link">
                      Ecommerce Website
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/website-management" className="sidebar-link">
                      Static / Dynamic Website
                    </Link>
                  </li>
                  <li>
                    <Link to="/products/custom-application" className="sidebar-link">
                      Custom Application
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Recent Blogs */}
              <div className="card p-3 shadow-sm">
                <h5 className="fw-bold mb-3 border-bottom border-2 pb-3">Recent Blogs</h5>

                {blogs.slice(0, 5).map((item) => (
                  <Link
                    key={item.id}
                    to={`/blog/${item.slug}`}
                    className="d-block mb-2 sidebar-link"
                  >
                    {item.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* 🔥 Custom CSS */}
      <style>{`
        .blog-card {
          transition: all 0.3s ease;
          border-radius: 12px;
          overflow: hidden;
        }

        .blog-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }

        .sidebar-link {
          text-decoration: none;
          color: #555;
          font-size: 14px;
        }

        .sidebar-link:hover {
          color: #000;
          padding-left: 5px;
          transition: 0.3s;
        }
      `}</style>
    </>
  );
}

export default Blogs;